import React, { useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./AboutMe.css";

export default function AboutMe(props) {
  
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTSANTS = {
    description:
      "I am a Final Year Computer Science underGrad from Birla Institute of Technology, Mesra having an interest in understanding and analyzing various aspects of a business and how things really work in the business world. I possess a strong background in Product Management, Problem Solving, and Critical thinking which enables me to identify opportunities for improvement and optimization within an organization. Also, I am currently working as a Product Management Intern at GameChange Solutions. GameChange is a well-recognized Singapore-based fintech startup that enables its customers to perform digital commerce and transactions over the peer-to-peer conversation on social media apps such as WhatsApp and Instagram. My day-to-day responsibilities as a PM Intern at GameChange vary from creating product requirement documents or BRD, attending demo sessions of our collaborators and partner companies, running SQL queries and commands on our snowflake database to get key insights of user engagement and interaction with one of our companies vertical ShopKey app.",
    highlights: {
      bullets: [
        "MySQL",
        "Tableau",
        "Advance Excel",
        "Business Intelligence",
        "Requirement Elicitation",
        "Case Study and BRD",
        "Product Development Life Cycle",
        "Managing Database",
        "Front End React Web Development",
      ],
      heading: "Here are a Few Highlights:",
    },
  };
  const renderHighlight = () => {
    return SCREEN_CONSTSANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlight-blob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div className="about-me-container screen-container" id={props.id || ""}>
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me?"} />
        <div className="about-me-card">
          <div className="about-me-profile"></div>
          <div className="about-me-details">
            <span className="about-me-description">
              {SCREEN_CONSTSANTS.description}
            </span>
            <div className="about-me-highlights">
              <div className="highlight-heading">
                <span>{SCREEN_CONSTSANTS.highlights.heading}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className="about-me-options">
              <button className="btn primary-btn" onClick={()=> ScrollService.scrollHandler.scrollToHireMe()}>Hire Me </button>
              <a href="Sourabh Agarwal Resume.pdf" download="Sourabh Agarwal Resume.pdf">
                <button className="btn highlighted-btn">Get Resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
